module.exports = __webpack_public_path__ + "static/vacay-ecom-f59631e774d8d2eac39a349efed5bc77.png";